export default {
  "content": "<path d=\"M17 6a1 1 0 011 1v10h-2V9.414l-9.793 9.793-1.414-1.414L14.586 8H7V6h10z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};